const routerArr = [
  {
    path: 'personalSet',
    name:"personalSet",
    component: (resolve) => require(["@/container/views/personalSet/index"], resolve),
    meta: { show: '1110', title: '账号管理', source: '11c2' }
  }
];

export default routerArr;



// WEBPACK FOOTER //
// ./src/container/views/personalSet/_res.js